var map = {
	"./033-bm.webp": 1228,
	"./033-cn.webp": 1229,
	"./033.webp": 1230,
	"./13-bm.webp": 1231,
	"./13-cn.webp": 1232,
	"./13.webp": 1233,
	"./3-bm.webp": 1234,
	"./3-cn.webp": 1235,
	"./3.webp": 1236,
	"./angpao-bg-mobile.jpg": 1237,
	"./angpao-bg.jpg": 1238,
	"./angpao-bm.webp": 1239,
	"./angpao-cn.webp": 1240,
	"./angpao.webp": 1241,
	"./button.png": 1242,
	"./close-eye.png": 1243,
	"./coin-1.png": 1244,
	"./coin.png": 1245,
	"./ketupak-open.png": 1246,
	"./ketupak.png": 1247,
	"./ketupak_ribbon.png": 1248,
	"./rain-1.png": 1249,
	"./rain-2.png": 1250,
	"./rain-3.png": 1251,
	"./raya-bg-mobile.png": 1252,
	"./raya-bg.png": 1253,
	"./shine.png": 1254,
	"./star-1.png": 1255,
	"./star-2.png": 1256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 460;